import { ProfileType } from '@lw-modules/onboarding-platform/enums';

export const profilesWithoutOnboarding = [
  ProfileType.Operator,
  ProfileType.Buyer,
  ProfileType.Donor,
  ProfileType.Payer
] as const;

export const isProfileWithoutOnboarding = (profileType?: ProfileType) =>
  Boolean(
    profileType &&
      profilesWithoutOnboarding.includes(profileType as (typeof profilesWithoutOnboarding)[number])
  );
